<!-- 车牌输入键盘 -->

<template>
	<div v-click-outside.stop="handleClickOutside">
		<div class="flex">
			<el-input ref="serachInputRef" :type="type" :autofocus="true" clearable class="search-input"
				v-model="keyBoardValue" :placeholder="placeholder" @input="inputEvent" @focus="showKey"
				@keyup.enter="onEnter" v-if="isShowInput" rows="3">
				<template #suffix v-if="isSearchIcon">
					<el-icon class="el-input__icon">
						<Search />
					</el-icon>
				</template>
				<template #append v-if="isShowAppend">元</template>
			</el-input>

			<el-button @click="onQueryBtn" class="confirm" style="padding: 12px 0;" :loading="isLoading">查询</el-button>
		</div>

		<!-- 地区 -->
		<div v-if="isShowKeyBoard">
			<div class="license-plate" style="max-width: 610px;margin-top: 10px;" v-if="keyBoardValue.length == 0">
				<ul class="">
					<li v-for="(key,index) in keyBoard.letterList" :key="index" track-by="$index" v-text="key"
						@click="clickKey(key)"></li>
				</ul>
			</div>

			<div style="max-width: 600px;margin-top: 10px;" v-else>
				<!-- 数字 -->
				<div class="license-plate"
					style="justify-content: center;background-color: var(--search-uncheck-bg-color);">
					<ul>
						<li v-for="(key,index) in keyBoard.digitList" :key="index" track-by="$index" v-text="key"
							@click="clickKey(key)"></li>
					</ul>
				</div>
				<!-- 第一排字母 -->
				<div class="license-plate"
					style="justify-content: center;background-color: var(--search-uncheck-bg-color);">
					<ul>
						<li v-for="(key,index) in keyBoard.englishKeyOneList" :key="index" track-by="$index"
							v-text="key" @click="clickKey(key)"></li>
					</ul>
				</div>
				<!-- 第二排字母 -->
				<div class="license-plate"
					style="justify-content: center;background-color: var(--search-uncheck-bg-color);">
					<ul>
						<li v-for="(key,index) in keyBoard.englishKeyTwoList" :key="index" track-by="$index"
							v-text="key" @click="clickKey(key)"></li>
					</ul>
				</div>
				<!-- 第三排字母 -->
				<div class="license-plate"
					style="justify-content: center;background-color: var(--search-uncheck-bg-color);">
					<ul>
						<li v-for="(key,index) in keyBoard.englishKeyThreeList" :key="index" track-by="$index"
							v-text="key" @click="clickKey(key)"></li>
					</ul>
				</div>
			</div>
		</div>
	</div>

</template>
<script setup>

	/**
	 * @author lili
	 * @param {String} v-model
	 * @param {function}  inputEvent 键入触发
	 * @param {String} placeholder
	 * @param {String} isSearchIcon  是否显示尾部图标
	 * @param {String} type  输入类型
	 * */

	import {
		reactive,
		watch,
		ref,
		defineExpose,
		nextTick,
		toRefs
	} from 'vue';
	import { Search } from "@element-plus/icons-vue";
	const isLoading = ref(false);  // 查询按钮加载状态
	const isShowKeyBoard = ref(true);  // 是否显示按键
	/**
	 * 
	 * 点击查询按钮
	 * 
	 * **/
	const onQueryBtn = () => {
		emit('onQueryBtn', keyBoardValue.value);
	}
	const vClickOutside = {
		mounted(el, binding) {
			function eventHandler(e) {
				if (el.contains(e.target)) {
					return false
				}
				// 如果绑定的参数是函数，正常情况也应该是函数，执行
				if (binding.value && typeof binding.value === 'function') {
					binding.value(e)
				}
			}
			// 用于销毁前注销事件监听
			el.__click_outside__ = eventHandler
			// 添加事件监听
			document.addEventListener('click', eventHandler)
		},
		beforeUnmount(el) {
			// 移除事件监听
			document.removeEventListener('click', el.__click_outside__)
			// 删除无用属性
			delete el.__click_outside__
		}
	}

	function inputEvent() {
		emit('update:modelValue', keyBoardValue.value)
		emit('inputEvent')
	}
	// 按enter键
	function onEnter() {
		emit('onEnter')
	}

	//点击组件外事件
	function handleClickOutside() {
		keyBoard.showKeyboard = false
	}
	const serachInputRef = ref(null)

	function serachInputRefFocus() {
		setTimeout(() => {
			nextTick(() => {
				serachInputRef.value.focus()
			})
		})
	}
	defineExpose({
		serachInputRefFocus,
		clickKey,
		showKey,
		clearContent,
		handleClickOutside,
		closeKey,
		isLoading,
		isShowKeyBoard,
	})

	const emit = defineEmits(['update:modelValue', 'inputEvent', 'onEnter', 'determineBtn', 'onShowKey', 'onQueryBtn',])
	const props = defineProps({
		placeholder: {
			type: String,
			default: ''
		},
		modelValue: {
			type: [String, Number],
			default: ''
		},
		isSearchIcon: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text'
		},
		isShowInput: {
			type: Boolean,
			default: true
		},
		leftNum: {
			type: [String, Number],
			default: '0'
		},
		// 是否显示输入框后置内容
		isShowAppend: {
			type: Boolean,
			default: false
		}
	})
	const {
		modelValue
	} = toRefs(props)
	watch(modelValue, (newValue, oldValue) => {
		keyBoardValue.value = newValue
	})


	const keyBoard = reactive({
		keyList: [],
		letterList: [],
		digitList: [],
		englishKeyOneList: [],
		englishKeyTwoList: [],
		englishKeyThreeList: [],
		showKeyboard: false,
	})

	function showKey() {
		keyBoard.showKeyboard = true;
		emit('onShowKey');
	}
	function closeKey() {
		keyBoard.showKeyboard = false;
	}
	const keyBoardValue = ref('')
	function clearContent() {
		keyBoardValue.value = '';
	}

	function clickKey(key) {
		if (key == '确定') {
			keyBoard.showKeyboard = false
			emit('determineBtn');
		} else {
			keyBoardValue.value += key
			emit('update:modelValue', keyBoardValue.value)
			emit('inputEvent', keyBoardValue.value)
		}

	}

	function ready() {
		keyBoard.keyList = [
			'1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.',
			'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
			'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z',
			'X', 'C', 'V', 'B', 'N', 'M',
		];
		keyBoard.letterList = [
			'京', '津', '沪', '渝', '冀', '晋', '辽', '吉', '黑',
			'苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘',
			'粤', '琼', '川', '贵', '云', '陕', '甘', '青', '桂',
			'蒙', '藏', '宁', '新',
		];
		keyBoard.digitList = [
			'1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
		];
		keyBoard.englishKeyOneList = [
			'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
		];
		keyBoard.englishKeyTwoList = [
			'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
		];
		keyBoard.englishKeyThreeList = [
			'Z', 'X', 'C', 'V', 'B', 'N', 'M',
		];
	}
	ready();
</script>

<style lang="scss" scoped>
	.search-input {
		/* width: 240px; */
		/* background-color: var(--text-white-color) !important; */

		::-webkit-input-placeholder {
			/* color: var(--theme-color); */
		}
	}

	.el-input__inner {
		background-color: var(--text-white-color) !important;
		border-radius: 50px;
	}

	.license-plate {
		margin-right: 10px;
		display: flex;

		ul {

			/* position: absolute; */
			padding: 0;
			list-style: none;
			user-select: none;
			z-index: 9999;
			/* box-shadow: 2px 1px 2px 2px var(--search-uncheck-bg-color); */
			padding: 5px;
			background-color: var(--search-uncheck-bg-color);
			/* display: grid; */
			grid-template-columns: repeat(3, 1fr);

			li {
				float: left;
				margin: 2px;
				width: 50px;
				height: 50px;
				line-height: 50px;
				text-align: center;
				background: var(--select--bg-color);
				border: 1px solid var(--select--bg-color);
				color: var(--text-color);
				border-radius: 5px;

				&:hover {
					position: relative;
					border-color: gray;
					cursor: pointer;
				}

				&:active {
					top: 1px;
					left: 1px;
				}
			}
		}

		.tab,
		.delete {
			width: 70px;
		}

		.capslock {
			width: 80px;
		}

		.enter {
			width: 77px;
		}

		.shift {
			width: 102px;
		}

		.space {
			clear: left;
			width: 660px;
		}

		.shifted {
			position: relative;
			top: 1px;
			left: 1px;
			border-color: #e5e5e5;
			cursor: pointer;
		}

		.capsed {
			position: relative;
			top: 1px;
			left: 1px;
			border-color: #e5e5e5;
			cursor: pointer;
		}
	}
</style>